"use client";

// ShepherdTourContext.tsx
import React, { createContext, useContext } from "react";
import Shepherd, { Tour } from "shepherd.js";
import "shepherd.js/dist/css/shepherd.css";

const ShepherdFactoryContext = createContext<() => Tour>(() => {
  throw new Error("ShepherdProvider missing");
});

export const ShepherdProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const createTour = () =>
    new Shepherd.Tour({
      useModalOverlay: true,
      defaultStepOptions: {
        classes: "custom-tour-step",
        scrollTo: true,
        cancelIcon: { enabled: true },
      },
    });

  return (
    <ShepherdFactoryContext.Provider value={createTour}>
      {children}
    </ShepherdFactoryContext.Provider>
  );
};

/**
 * Returns a new Shepherd.Tour instance per component (memoized so it sticks
 * for the lifetime of that component instance).
 */
export const useShepherd = () => {
  const create = useContext(ShepherdFactoryContext);
  if (!create)
    throw new Error("useNewShepherdTour must be used within ShepherdProvider");
  // each consumer gets its own tour instance
  return React.useMemo(() => create(), [create]);
};
